import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { roleIdParam, userIdParam } from './builderHelper';

export const userResources = {
  createUser: createResourceBuilder('/identities/user', EResourceMethod.Post),
  updateUser: createResourceBuilder('/identities/user/:user_id', EResourceMethod.Patch, userIdParam()),
  getUser: createResourceBuilder('/identities/user/:user_id', EResourceMethod.Get, userIdParam()),
  getUserInfo: createResourceBuilder('/identities/user/:user_id/info', EResourceMethod.Get, userIdParam()),
  getCurrentUserInfo: createResourceBuilder('/identities/user/me/info', EResourceMethod.Get),
  getUsers: createResourceBuilder('/identities/user', EResourceMethod.Get),
  getUsersByIds: createResourceBuilder('/identities/user/by-ids', EResourceMethod.Get),
  getUsersByRoles: createResourceBuilder('/identities/by-roles', EResourceMethod.Get),
  getAdmins: createResourceBuilder('/identities/user/admins', EResourceMethod.Get),
  assignRole: createResourceBuilder('/identities/user/:user_id/role', EResourceMethod.Post, userIdParam()),
  updateDefaultOrganization: createResourceBuilder(
    '/identities/user/:user_id/set-default-organization/:organization_id',
    EResourceMethod.Patch,
    userIdParam()
  ),
  acceptUserAgreement: createResourceBuilder(
    '/identities/user/:user_id/aggreemenets',
    EResourceMethod.Patch,
    userIdParam()
  ),
  requestEmailChange: createResourceBuilder(
    '/identities/user/:user_id/request-change-email',
    EResourceMethod.Post,
    userIdParam()
  ),
  submitEmailChange: createResourceBuilder('/identities/user/change-email', EResourceMethod.Post),
  getMfaStatus: createResourceBuilder('/identities/user/:user_id/2fa', EResourceMethod.Get, (user_id: string) => ({
    user_id,
  })),
  getMfaDevices: createResourceBuilder(
    '/identities/user/:user_id/mfa-devices',
    EResourceMethod.Get,
    (user_id: string) => ({
      user_id,
    })
  ),
  revokeUserRole: createResourceBuilder(
    '/identities/user/:user_id/role/:role_id',
    EResourceMethod.Delete,
    userIdParam(roleIdParam())
  ),
  deleteUser: createResourceBuilder('/identities/user/:user_id', EResourceMethod.Delete, userIdParam()),
} as const;
